
import React from 'react'

const PageHeader = (props) => {
  return (
    <div className="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 className="text-lg font-medium mr-auto">{props.title}</h2>
      {
        props.RigthActionButtonTitle &&
        (<div className="w-full sm:w-auto flex mt-4 sm:mt-0">
          <a
            href={props.RigthActionButtonRoute}
            className="bg-dark-2 text-white p-4 shadow-md mr-2"
          >
            {props.RigthActionButtonTitle}
          </a>
        </div>
        )
      }
    </div>
  );
}

export default PageHeader

